import CompoundSearch from './CompoundSearch';

export default CompoundSearch;
